module.exports = __webpack_public_path__ + "files/ef7c3617a454b59c282e55c6bb142cc1.png";